import firebase from 'firebase';

import IOAuthProvider from 'shared/domain/providers/IOAuthProvider';
import 'firebase/auth';

const GOOGLE_PEOPLE_API_PHONE_URL =
  'https://people.googleapis.com/v1/people/me?personFields=phoneNumbers';

const BRAZIL_COUNTRY_CODE = '55';
const BRAZILIAN_PHONE_DIGIT_COUNTS_WITH_COUNTRY_CODE = [12, 13];

interface IGooglePeopleResponse {
  phoneNumbers?: Array<{ value: string; canonicalForm?: string }>;
}

export default class GoogleFirebaseOAuthProvider implements IOAuthProvider {
  private provider: firebase.auth.GoogleAuthProvider;
  private auth: firebase.auth.Auth;

  constructor() {
    firebase.initializeApp({
      apiKey: 'AIzaSyAHX1rUkfqwDBCb3RJMcZbBPphzunv1wO8',
      authDomain: 'vialaser-auth.firebaseapp.com',
      databaseURL: 'https://vialaser-auth.firebaseio.com',
      projectId: 'vialaser-auth',
      storageBucket: 'vialaser-auth.appspot.com',
      messagingSenderId: '999147183124',
      appId: '1:999147183124:web:57f82671222dad5a975b01',
      measurementId: 'G-0DCRV0QQKF',
    });

    this.provider = new firebase.auth.GoogleAuthProvider();
    this.auth = firebase.auth();
  }

  public getSocialUser: IOAuthProvider['getSocialUser'] = async () => {
    this.provider.addScope('profile');
    this.provider.addScope('email');
    this.provider.addScope(
      'https://www.googleapis.com/auth/user.birthday.read',
    );
    this.provider.addScope(
      'https://www.googleapis.com/auth/user.phonenumbers.read',
    );

    this.auth.useDeviceLanguage();

    const response = await this.auth.signInWithPopup(this.provider);

    if (!response.user) return null;

    const token = await response.user.getIdToken();
    const phone = await this.fetchGooglePhoneNumber(response.credential);

    return { token, phone };
  };

  private async fetchGooglePhoneNumber(
    credential: firebase.auth.AuthCredential | null,
  ) {
    const accessToken = (credential as firebase.auth.OAuthCredential | null)
      ?.accessToken;

    if (!accessToken) return null;

    try {
      const response = await fetch(GOOGLE_PEOPLE_API_PHONE_URL, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      if (!response.ok) return null;

      const data: IGooglePeopleResponse = await response.json();
      const rawPhone =
        data.phoneNumbers?.[0]?.canonicalForm || data.phoneNumbers?.[0]?.value;

      return rawPhone ? this.normalizePhone(rawPhone) : null;
    } catch {
      return null;
    }
  }

  private normalizePhone(rawPhone: string) {
    const digits = rawPhone.replace(/\D/g, '');

    if (
      BRAZILIAN_PHONE_DIGIT_COUNTS_WITH_COUNTRY_CODE.includes(digits.length) &&
      digits.startsWith(BRAZIL_COUNTRY_CODE)
    ) {
      return digits.slice(BRAZIL_COUNTRY_CODE.length);
    }

    return digits;
  }
}
